export default {
    brand_overview_title: 'Marca',
    brand_overview_actions: 'Acciones',
    brand_overview_tab_dealers: 'Distribuidores',
    brand_overview_tab_message_templates: 'Plantillas de Mensajes',
    brand_overview_code: 'Código',
    brand_overview_title: 'Título',
    brand_overview_domains: 'Dominios',

    brand_overview_username: 'Nombre de Usuario',
    brand_overview_opened_at: 'Abierto en',
    brand_overview_status: 'Estado',
    brand_overview_package: 'Paquete',
    brand_overview_devices: 'Dispositivos',
    brand_overview_brand: 'Marca',
    brand_overview_crm: 'Id. de Salesforce',
    brand_overview_activities: 'Actividades',
    brand_overview_keysfobs: 'Llaves',
    brand_overview_user: 'Usuarios',
    brand_overview_edit_brand: 'Editar Marca',
    brand_overview_reset_legacy_user: 'Restablecer la Contraseña del Marca',
    brand_overview_change_brand_status: 'Cambiar el Estado del Marca',
    brand_overview_change_brand_brand: 'Cambiar la Marca del Marca',
    brand_overview_import_and_assign: 'Importar y Asignar',
    brand_overview_reset_cognito_user: 'Restablecer la Autenticación de Cognito',
    brand_overview_device_models: 'Modelos de Dispositivos',
    brand_overview_part_numbers: 'Números de Pieza',
    brand_overview_unit_types: 'Tipos de Unidades',
    brand_overview_active_devices: 'Dispositivos Activos',
    brand_overview_system_alert_logs: 'Logs Sistema de Alertas',
    brand_overview_scheduled_reports: 'Reportes Programados',
    brand_overview_email: 'Correo electrónico',
    brand_overview_export_logs: 'Registros de Exportación',
    brand_overview_terms_conditions: 'Verificar los términos y condiciones',
    brand_overview_scheduled_actions: 'Acciones programadas',
    brand_overview_change_username: 'Cambiar el Nombre de Usuario',

    brand_overview_master_company: 'Empresa Maestra',
    brand_overview_tab_accounts: "Cuentas",
    brand_overview_tab_packages: "Paquetes",
};